import { IChildMenuScope, IMenuItemScope } from "./menu";

export function QpMenuDirective($timeout: angular.ITimeoutService, $injector: angular.auto.IInjectorService): angular.IDirective {
    return {
        restrict: "AE",
        scope: {
            // 菜单模式:horizontal|vertical
            mode: "<"
        },
        controllerAs: "ctrl",
        require: ["^?qpMenu"],
        controller: ["$scope", function ($scope) {

            /*************************************** */

            let vm = this;
            vm.menuList = [];
            vm.hasChildItem = {};

            /**
             * @description 添加菜单项
             * @param item 
             */
            vm.addItem = function (menuItem: IMenuItemScope) {
                if (angular.isUndefined(vm.menuList)) {
                    vm.menuList = [];
                }
                vm.menuList.push(menuItem)
            }

            /**
             * @description 添加子菜单
             * @param pid 
             */
            vm.updateChildMenu = function (pid: string, childCtrl) {
                if (angular.isUndefined(vm.hasChildItem)) {
                    vm.hasChildItem = {}
                }

                childCtrl.menuList.forEach(item => {
                    if (angular.isUndefined(vm.hasChildItem[pid])) {
                        vm.hasChildItem[pid] = {
                            childMenu: item,
                            pid: pid,
                            parentCtrl: childCtrl
                        }
                    }
                })

            }

            vm.childMouseover = function (parentId: string) {
                // 鼠标经过,若存在子导航则展开子导航
                const targetMenu = vm.getChildMenu(parentId);
                if (targetMenu) {
                    targetMenu.parentCtrl.isShow = true;                    
                }
            }


            vm.childMouseout = function (parentId: string) {
                // 鼠标经过,若存在子导航则展开子导航
                const targetMenu = vm.getChildMenu(parentId);
                if (targetMenu) {
                    targetMenu.parentCtrl.isShow = false;
                }
            }

            /**
             * @description 检查指定菜单项是否有子菜单
             */
            vm.getChildMenu = function (parentId: string): IMenuItemScope | undefined {
                if (angular.isUndefined(parentId)) {
                    return undefined;
                }
                return vm.hasChildItem[parentId];
            }




            /*************************************** */

















            vm.removeItem = function (id: string) {

            }


            vm.childClick = function () {

            }

        }],
        link: (scope, elem: JQLite, attr, ctrls: Array<angular.IController>) => {
            const selfCtrl = ctrls[0];

        }
    }
}

QpMenuDirective.$inject = ["$timeout", "$injector"];